import { flux } from '@/core/flux.module';
import { ConditionProperty } from '@/hybrid/tools/conditionWithProperties/conditionWithProperties.store';

export const addProperty = () => flux.dispatch('CONDITION_WITH_PROPERTIES_ADD_PROPERTY');

export const removeProperty = (index: number) => flux.dispatch('CONDITION_WITH_PROPERTIES_REMOVE_PROPERTY', index);

export const updateProperty = (payload: { value: Partial<ConditionProperty>; index: number }) =>
  flux.dispatch('CONDITION_WITH_PROPERTIES_UPDATE_PROPERTY', payload);
